const inicialState = {
  tab: '0',
  dataInicio: '',
  dataFim: '',
  filtroValue: '',
  imprimir: false,
};

export default inicialState;



// WEBPACK FOOTER //
// ./src/pages/arquivamento/common/store/arquivamento.state.js